import {
  DataTableColumnSwitchProps,
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '@/components/data-table-builder/data-table.types';
import { MeetingRoleEnum, Participant } from '@/types/meeting.types';

interface IgetInvitationDataTableStructureProps {
  createAction?: () => void;
  rowActions?: any;
  onSwitchChange?: (row: Participant, value: boolean) => void;
  onSwitchChangePresidency?: (row: Participant, value: boolean) => void;
  presentation?: boolean;
}

export const getPresenceDataTableStructure = ({
  onSwitchChange,
  createAction,
  onSwitchChangePresidency,
  presentation,
}: IgetInvitationDataTableStructureProps): DynamicDataTable => {
  const firstNameColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'meeting.presence.table.firstName',
    accessorKey: 'prenom',
    variant: DataTableColumnVariant.TEXT,
  };

  const lastNameColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'meeting.presence.table.lastName',
    accessorKey: 'nom',
    variant: DataTableColumnVariant.TEXT,
  };

  const functionColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'meeting.presence.table.function',
    accessorKey: 'fonction',
    variant: DataTableColumnVariant.TEXT,
  };

  const presentColumn: DynamicDataTableColumn<DataTableColumnSwitchProps> = {
    label: 'meeting.presence.table.present',
    accessorKey: 'present',
    variant: DataTableColumnVariant.SWITCH,
    props: {
      disabled: !onSwitchChange,
      onChange: (event: any, value: any, row: Participant) => onSwitchChange?.(row, event.checked),
    },
  };

  const presenceColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'meeting.presence.table.present',
    accessorKey: 'present',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: string) => {
      return {
        value: value ? 'Présent' : 'Absent',
      };
    },
  };

  const isPresidentColumn: DynamicDataTableColumn<DataTableColumnSwitchProps> = {
    label: 'meeting.presence.table.isPresident',
    accessorKey: 'fonctionReunion',
    variant: presentation ? DataTableColumnVariant.TEXT : DataTableColumnVariant.SWITCH,
    renderAs: (value: MeetingRoleEnum) => {
      return {
        value: presentation ? (value === MeetingRoleEnum.PRESIDENT ? 'Président' : '---') : value === MeetingRoleEnum.PRESIDENT,
      };
    },
    props: {
      disabled: !onSwitchChangePresidency,
      onChange: (event: any, value: any, row: Participant) => onSwitchChangePresidency?.(row, event.checked),
    },
  };

  return {
    singular: 'meeting.presence.singular',
    plural: 'meeting.presence.plural',
    columns: [lastNameColumn, firstNameColumn, functionColumn, presentation ? presenceColumn : presentColumn, isPresidentColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    createAction,
    searchableFields: ['prenom', 'nom', 'fonction'],
    rowRenderOverride: (row: Participant) => {
      return {
        class: row.fonctionReunion === MeetingRoleEnum.PRESIDENT ? 'bg-green-100 dark:bg-green-900' : '',
      };
    },
  };
};
